export default "__VITE_ASSET__8b10e160__"